import { createContext, Dispatch, ReactNode, SetStateAction, use, useState } from 'react'

type CommandPaletteContextType = {
    isOpen: boolean
    open: () => void
    setIsOpen: Dispatch<SetStateAction<boolean>>
}
export const CommandPaletteContext = createContext<CommandPaletteContextType | null>(null)

export const CommandPaletteProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false)

    const open = () => setIsOpen(true)

    return <CommandPaletteContext value={{ isOpen, open, setIsOpen }}>{children}</CommandPaletteContext>
}

export const useCommandPalette = () => {
    const context = use(CommandPaletteContext)
    if (!context) {
        throw new Error('useCommandPalette must be used within a CommandPaletteProvider.')
    }
    return context
}
